/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './product-attributes/product-attributes.component';
export * from './product-attributes/product-attributes.module';
export * from './product-details-tab/product-details-tab.component';
export * from './product-details-tab/product-details-tab.module';
export * from './product-reviews/product-reviews.component';
export * from './product-reviews/product-reviews.module';
export * from './product-tabs.module';
